import IndustryAutoComplete from './IndustryAutoComplete';

export default IndustryAutoComplete;
